module.exports = __webpack_public_path__ + "static/media/legacy_background.fa3fefc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/legacy_background.jpg
// module id = 127
// module chunks = 0